<template>
    <page :busy="busy">
        <div v-if="finishedLoading">
            <b-container fluid class="my-3">
                <b-row class="control-panel-button-row">
                    <b-col md="12">
                        <div>
                            <b-button
                                class="w-sm-100 control-panel-button"
                                size="lg"
                                variant="primary"
                                @click="goToControlPanel()"
                                :disabled="busy"
                                >{{ controlPanelButtonLabel }} &nbsp;&nbsp;<font-awesome-icon v-if="!redirectToInbox" rotation="90" :icon="['fas', 'sliders']"/><font-awesome-icon v-else :icon="['fas', 'envelope']"/></b-button
                            >
                        </div>
                    </b-col>
                </b-row>            
                <reservation-details-form
                    :is-create="false"
                    :alteration-id="alterationId"
                    :has-published-owner-statement="reservationDetails.has_published_owner_statement"
                    :initial-values="{
                        id: reservationDetails.id,
                        user_id: reservationDetails.user_id,
                        booking_method: reservationDetails.booking_method,
                        full_name: reservationDetails.full_name,
                        email: reservationDetails.email,
                        first_name: reservationDetails.first_name,
                        last_name: reservationDetails.last_name,
                        from_date: reservationDetails.from_date,
                        to_date: reservationDetails.to_date,
                        auto_generate: reservationDetails.auto_generate,
                        is_quote: reservationDetails.is_quote,
                        properties: reservationDetails.properties,
                        adults: reservationDetails.adults,
                        children: reservationDetails.children,
                        pets: reservationDetails.pets,
                        stay_type: reservationDetails.stay_type,
                        tax_exemption: reservationDetails.tax_exemption,
                        tax_exemption_code: reservationDetails.tax_exemption_code,
                        inquiry_source: reservationDetails.inquiry_source,
                        airbnb_data_lodgix_status: reservationDetails.airbnb_data_lodgix_status,
                    }"
                    ref="reservationDetailsForm"
                ></reservation-details-form>
            </b-container>
        </div>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
    import { invoiceMixin } from '../mixins/invoice-mixin';
    import Page from '../../generic/page/page.vue';
    import Reservation from '../reservation.vue';
    import ReservationDetailsForm from './reservation-details-form.vue';
    import { RESERVATION_DETAILS_INQUIRY_SOURCE_DATA_ENDPOINT } from '../../../endpoints';

    export default {
        //extends: Reservation,
        name: 'ReservationDetailsEdit',
        mixins: [removeScrollMixin, invoiceMixin],
        components: {
            ReservationDetailsForm,
            Page,
        },
        computed: {
            ...mapGetters('reservation', ['reservationDetails']),
            reservationId() {
                return parseInt(this.$route.params.id);
            },
            alterationId() {
                const alterationId = this.$route.params.alterationId;
                return alterationId !== undefined ? alterationId : null;
            },
            isQuote() {
                return this.reservationDetails.is_quote;
            },            
        },
        data() {
            return {
                finishedLoading: false,
            };
        },
        mounted() {
            this.$store.commit('reservation/resetReservationDetails');

            (async () => {
                this.busy = true;
                try {
                    await this.fetchReservationDetails();
                } finally {
                    this.busy = false;
                    this.finishedLoading = true;
                }
            })();
        },
        beforeUnmount() {
            this.$store.commit('reservation/resetReservationDetails');
        },
        methods: {
            async fetchReservationDetails() {
                try {
                    await this.$store.dispatch('reservation/fetchReservationDetails', { id: this.reservationId });
                } catch (err) {
                    this.errorToast({ text: 'Could not load reservation data.' });
                }
            }           
        },
    };
</script>


<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .control-panel-button-row {
        margin-bottom: 15px !important;
    }
    
    @include media-breakpoint-down(sm) {
        :deep(.control-panel-button-row) {
            margin-bottom: 0 !important;
        }        
    }
    
    @include media-breakpoint-down(md) {
        :deep(.w-sm-100) {
            width: 100% !important;
        }
        :deep(.control-panel-button-row) {
            display: block !important;
        }        
    }
    
    @include media-breakpoint-down(lg) {
        :deep(.control-panel-button-row) {
            display: block !important;
        }        
    }    
    
    @include media-breakpoint-up(lg) {
        :deep(.control-panel-button-row) {
            display: none !important;
        }
    }            
    
</style>
